<mat-toolbar>
  <span>Gestion des comptes</span>
  <span class="spacer"></span>
  <app-filiale-selector></app-filiale-selector>
  <app-officine-selector type="GestionComptes"></app-officine-selector>
</mat-toolbar>

<mat-tab-group (selectedTabChange)="tabChanged($event)" animationDuration="0ms" class="remove-border-bottom"
  color="accent" fitInkBarToContent mat-stretch-tabs="false">
  <!--  TAB -->
  <mat-tab [label]="'UTILISATEURS'">
    @if (activeTab === 0) {
    <app-utilisateurs></app-utilisateurs>
    }
  </mat-tab><mat-tab [label]="'DEMANDES'">
    @if (activeTab === 1) {
    <app-demandes></app-demandes>
    }
  </mat-tab>
</mat-tab-group>